import type { ReceiptTemplate } from '../schema';

export const monclerTemplate: ReceiptTemplate = {
  id: 'moncler',
  name: 'Moncler Receipt',
  brand: 'MONCLER',
  description: 'Moncler luxury outerwear receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'moncler-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MONCLER',
        businessNameFontSize: 20,
        addressLines: [
          '654 MADISON AVENUE',
          'NEW YORK, NY 10065',
          '(212) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'moncler-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans #:', value: '28451' },
          { id: 'assoc', label: 'Associate:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '15:42' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'moncler-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MAYA DOWN JACKET', quantity: '1', price: '1695.00', sku: 'MC847291' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'moncler-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1695.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (8.875%)', value: '150.43', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1845.43', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'moncler-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'AMEX ****7829',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'moncler-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'RETURNS WITHIN 14 DAYS\nWITH ORIGINAL RECEIPT\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

